/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuildingPublic { 
    Name: string;
    Id: string;
    Latitude: number | null;
    Longitude: number | null;
    CreationDate: string;
    LastEdit: string | null;
    LastEditBy: string | null;
    CustomerId: string;
    AreaCount: number;
}

